/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const da_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const de_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const en_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const es_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const fr_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const hu_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const it_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const nl_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const pl_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const pt_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

const sv_regions_us_montana3 = /** @type {(inputs: {}) => string} */ () => {
	return `Montana`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const regions_us_montana3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.regions_us_montana3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("regions_us_montana3", locale)
	if (locale === "cs") return cs_regions_us_montana3(inputs)
	if (locale === "da") return da_regions_us_montana3(inputs)
	if (locale === "de") return de_regions_us_montana3(inputs)
	if (locale === "en") return en_regions_us_montana3(inputs)
	if (locale === "es") return es_regions_us_montana3(inputs)
	if (locale === "fr") return fr_regions_us_montana3(inputs)
	if (locale === "hu") return hu_regions_us_montana3(inputs)
	if (locale === "it") return it_regions_us_montana3(inputs)
	if (locale === "nl") return nl_regions_us_montana3(inputs)
	if (locale === "pl") return pl_regions_us_montana3(inputs)
	if (locale === "pt") return pt_regions_us_montana3(inputs)
	return sv_regions_us_montana3(inputs)
};
export { regions_us_montana3 as "regions.US.Montana" }